// YouTubeチャンネルURLからチャンネル識別子(channelId)を取り出す。
//
// ブラウザのアドレスバーからコピーしたURLは、日本語ハンドルがパーセント
// エンコードされた状態になっている。
//   https://www.youtube.com/@%E3%81%A0%E3%81%84%E3%81%93%E3%81%86-...
// そのまま最後のセグメントを取ると "%E3%81%A0..." が channelId になって
// しまうため、必ずデコードして "@だいこう-..." に戻す。

// /@handle/videos のように、チャンネル配下のサブページが付いたURLを
// 貼られることがあるので、末尾がこれらの場合は取り除く
const SUB_PAGES = new Set([
  "videos",
  "shorts",
  "streams",
  "live",
  "playlists",
  "community",
  "posts",
  "channels",
  "about",
  "featured",
  "podcasts",
  "releases",
  "store",
  "search",
]);

// /channel/UCxxxx, /c/name, /user/name のようにプレフィックスが付く形式
const PREFIXED = new Set(["channel", "c", "user"]);

const decodeSegment = (segment) => {
  try {
    return decodeURIComponent(segment);
  } catch (err) {
    // 不正なパーセントエンコードはデコードせずそのまま扱う
    return segment;
  }
};

const toUrl = (raw) => {
  try {
    return new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
  } catch (err) {
    return null;
  }
};

// 戻り値: "@だいこう-ろリゆにこーん" / "UCxxxxxxxx" / "" (取り出せなかった場合)
export const parseYoutubeChannelId = (input) => {
  const raw = (input ?? "").trim();

  if (!raw) {
    return "";
  }

  // "@handle" や "UCxxxx" を直接入力された場合はURL解析しない
  if (!raw.includes("/")) {
    return decodeSegment(raw);
  }

  const url = toUrl(raw);

  if (!url) {
    return "";
  }

  const segments = url.pathname
    .split("/")
    .filter((segment) => segment.length > 0)
    .map(decodeSegment);

  // 末尾のサブページを落とす (/@handle/videos → /@handle)
  while (
    segments.length > 1 &&
    SUB_PAGES.has(segments[segments.length - 1].toLowerCase())
  ) {
    segments.pop();
  }

  if (segments.length === 0) {
    return "";
  }

  if (PREFIXED.has(segments[0].toLowerCase())) {
    return segments[1] ?? "";
  }

  return segments[0];
};
